import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const getPersonalizationBlock = (code, cartId, customerId) => {
  let urlString = '';
  if (cartId) {
    urlString += `&cartId=${cartId}`;
  }
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  return axios.get(
    `${getV2RootUrl()}/personalization-block/code/${code}/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};
